"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectEventType = void 0;
var ConnectEventType;
(function (ConnectEventType) {
    ConnectEventType["UNIT_CREATED"] = "unit-created";
    ConnectEventType["UNIT_CHANGED"] = "unit-changed";
    ConnectEventType["UNIT_STATUS"] = "unit-status";
    ConnectEventType["AVAILABILITY_CREATED"] = "availability-created";
    ConnectEventType["AVAILABILITY_CHANGED"] = "availability-changed";
    ConnectEventType["AVAILABILITY_STATUS"] = "availability-status";
    ConnectEventType["RESERVATION_CREATED"] = "reservation-created";
    ConnectEventType["RESERVATION_CHANGED"] = "reservation-changed";
    ConnectEventType["RESERVATION_STATUS"] = "reservation-status";
    ConnectEventType["RESERVATION_GUEST_CREATED"] = "reservation-guest-created";
    ConnectEventType["RESERVATION_GUEST_CHANGED"] = "reservation-guest-changed";
    ConnectEventType["RESERVATION_GUEST_STATUS"] = "reservation-guest-status";
    ConnectEventType["CONTRACT_CREATED"] = "contract-created";
    ConnectEventType["CONTRACT_CHANGED"] = "contract-changed";
    ConnectEventType["CONTRACT_STATUS"] = "contract-status";
    ConnectEventType["OWNER_CREATED"] = "owner-created";
    ConnectEventType["OWNER_CHANGED"] = "owner-changed";
    ConnectEventType["OWNER_STATUS"] = "owner-status";
    ConnectEventType["AMENITY_CREATED"] = "amenity-created";
    ConnectEventType["AMENITY_CHANGED"] = "amenity-changed";
    ConnectEventType["AMENITY_STATUS"] = "amenity-status";
    ConnectEventType["REVIEW_CREATED"] = "review-created";
    ConnectEventType["REVIEW_CHANGED"] = "review-changed";
    ConnectEventType["REVIEW_STATUS"] = "review-status";
    ConnectEventType["UNIT_CONTENT_CREATED"] = "unit-content-created";
    ConnectEventType["UNIT_CONTENT_CHANGED"] = "unit-content-changed";
    ConnectEventType["UNIT_CONTENT_STATUS"] = "unit-content-status";
})(ConnectEventType = exports.ConnectEventType || (exports.ConnectEventType = {}));
//# sourceMappingURL=connect-events.types.js.map